module.exports = __webpack_public_path__ + "img/dirty-bird-since.407ddd71.jpg";